import styled from '@emotion/styled';

import { themeGroupBorder } from 'pages/WebsiteDesignsPLPV2/components/PLPThemeGroup/PLPThemeGroup.styles';

import { COLORS3, FONT, MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';

export const CalloutContainer = styled.div`
  align-items: center;
  border-bottom: ${themeGroupBorder};
  border-right: ${themeGroupBorder};
  display: flex;
  flex-flow: column;
  justify-content: center;
  max-width: 100%;
  padding: ${SPACING.S16} ${SPACING.S16} ${SPACING.S32} ${SPACING.S16};
  width: 100%;

  ${MEDIA_QUERY.MOBILE} {
    button {
      min-height: 44px;
      height: auto;
    }
  }
`;

export const CalloutTxt = styled.h3`
  color: ${COLORS3.BLACK_100};
  font-family: ${FONT.FAMILY.SANS_SERIF};
  font-size: 42px;
  font-weight: ${FONT.WEIGHT.REGULAR};
  letter-spacing: -0.04em;
  line-height: 42px;
  margin: 0 0 ${SPACING.S32} 0;
  max-width: 415px;
  text-align: center;
  width: 100%;

  span {
    font-family: ${FONT.FAMILY.SERIF};
    font-weight: ${FONT.WEIGHT.MEDIUM};
  }

  ${MEDIA_QUERY.MOBILE} {
    font-size: ${FONT.SIZE.LARGER};
    line-height: ${FONT.SIZE.LARGER};
  }
`;
